<template>
    <div class="Work">
        <el-calendar v-model="value">
            <template slot="dateCell" slot-scope="{date, data}">
                <p :class="data.isSelected ? 'is-selected' : ''">
                    {{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : '' }}
                </p>
            </template>
        </el-calendar>
        <div id="work-setting">
            <el-descriptions class="margin-top" title="当日工作信息" :column="3" border v-if="false">
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        填写人
                    </template>
                    kooriookami
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        完成时间
                    </template>
                    18100000000
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-location-outline"></i>
                        附件
                    </template>
                    苏州市
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        工作类别
                    </template>
                    <el-tag size="small">学校</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-office-building"></i>
                        工作内容
                    </template>
                    江苏省苏州市吴中区吴中大道 1188 号
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div id="work-list">
            <div style="display: flex;">
                <h5 style="text-align:left;margin-bottom: 20px; font-size: 20px">已完成工作</h5>
                <el-button style="height:35px;position: absolute;right: 50px" type="primary" size="small"
                    @click="dialogVisible = true">新建/修改</el-button>
            </div>

            <template style="margin-top:;">
                <el-table :data="tableDataList" border style="width: 100%">
                    <el-table-column fixed prop='name' label="完成人" width="120">
                    </el-table-column>
                    <el-table-column prop="date" label="完成日期" width="160">
                    </el-table-column>
                    <el-table-column prop="worktype" label="工作类别" width="100">
                    </el-table-column>
                    <el-table-column prop="ischeak" label="审查" width="60">
                    </el-table-column>
                    <el-table-column prop="reporter" label="审查人" width="100">
                    </el-table-column>
                    <el-table-column prop="content" label="工作内容">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="160">
                        <template slot-scope="scope">
                            <el-button @click="Deletworkdata(scope.row)" type="text" size="small">删除</el-button>
                            <el-button @click="editWork(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button type="text" size="small" @click="showMessage((scope.row))">查看留言</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <!--新建/修改窗口-->
        <el-dialog title="工作信息" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
            <el-form ref="tableData" v-model="tableData" label-width="80px" style="text-align:left;">
                <el-form-item label="填报用户">
                    <el-input disabled v-model="username"></el-input>
                </el-form-item>
                <el-form-item label="填报日期">
                    <el-input disabled v-model="value"></el-input>
                </el-form-item>
                <el-form-item label="汇报人员">
                    <el-select v-model="reportervalue" filterable placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工作类型">
                    <el-radio-group v-model="tableData.worktype">
                        <el-radio label="本职工作"></el-radio>
                        <el-radio label="学习/研究"></el-radio>
                        <el-radio label="其他"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="工作内容">
                    
                    <el-input type="textarea" v-model="tableData.content" placeholder="阐述工作内容"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" style="margin-right:20px ;">立即创建</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--新建/修改窗口-->
        <!--编辑工作窗口-->
        <el-dialog title="工作信息" :visible.sync="EditdialogVisible" width="500px" :before-close="handleClose">
            <el-form ref="tableData" v-model="EdittableData" label-width="80px" style="text-align:left;">
                <el-form-item label="填报用户">
                    <el-input disabled v-model="username"></el-input>
                </el-form-item>
                <el-form-item label="填报日期">
                    <el-input disabled v-model="value"></el-input>
                </el-form-item>
                <el-form-item label="汇报人员">
                    <el-select v-model="Editreportervalue" filterable placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工作类型">
                    <el-radio-group v-model="EdittableData.worktype">
                        <el-radio label="本职工作"></el-radio>
                        <el-radio label="学习/研究"></el-radio>
                        <el-radio label="其他"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="工作内容">
                    <el-input type="textarea" v-model="EdittableData.content" placeholder="阐述工作内容"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="editWorkSubmit" style="margin-right:20px ;">提交修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--编辑工作窗口-->
    </div>

</template>
<style scoped src="../style/work.css">

</style>
<script>
import { Alert } from 'element-ui';
export default {
    name: "Work",
    data() {
        return {
            username: '',
            value: new Date().toLocaleDateString(),
            EditdialogVisible:false,
            dialogVisible: false,
            tableDataList: [],
            //新建工作的数据源
            tableData: {
                worktype: '本职工作',
                content: '',
                reporter: ''
            },
            //编辑工作的数据源
            EdittableData: {
                workid:'',
                worktype: '',
                content: '',
            },
            options: [],
            reportervalue: '',
            Editreportervalue:'',
            workMessage:''
        }
    },
    methods: {
        editWork(row) {
            if(row.ischeak != '√')
            {
                this.EdittableData.workid = row.id;
                this.EdittableData.worktype = row.worktype;
                this.EdittableData.content = row.content;
                this.Editreportervalue = row.reporter;
                this.EditdialogVisible = true;
            }
            else {
                alert("无法编辑审核合格的工作")
            }
           
        },
        editWorkSubmit()
        {
            this.$axios({
                url: this.apiurl +
                    "UserWork/EditWork?id=" + this.EdittableData.workid +
                    '&worktype=' + this.EdittableData.worktype +
                    '&workcontent=' + this.EdittableData.content +
                    '&checker=' + this.Editreportervalue
            }).then((res) => {
                if (res.status == 200) {
                    alert("修改成功");
                    this.dialogVisible = false;
                    this.$router.go(0)
                }

            }, (err) => {
                console.log(err.message);
            });
        },
        showMessage(row) {
            this.workMessage = '';
            this.$axios({
                url: this.apiurl +
                    "UserWork/GetMessageByWorkId?workid=" + row.id
            }).then((res) => {
                if (res.status == 200) {
                    console.log(res.data)
                    confirm(res.data)
                }

            }, (err) => {
                console.log(err.message);
            });
        },
        onSubmit() {
            this.$axios({
                url: this.apiurl +
                    "UserWork/EnterWork?id=" + this.$store.state.userid +
                    '&name=' + this.username +
                    '&worktype=' + this.tableData.worktype +
                    '&workcontent=' + this.tableData.content +
                    '&Reporter=' + this.reportervalue
            }).then((res) => {
                if (res.status == 200) {
                    alert("创建成功");
                    this.dialogVisible = false;
                    this.$router.go(0)
                }

            }, (err) => {
                console.log(err.message);
            });
        },
        Deletworkdata(row) {
            {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (row.ischeak != '√') {
                        this.$axios({
                            url: this.apiurl +
                                "UserWork/DeletWorkByWorkId?id=" + row.id
                        }).then((res) => {
                            if (res.status == 200) {
                                this.$router.go(0);
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            }

                        }, (err) => {
                            console.log(err.message);
                        });
                    }
                    else {
                        alert("无法删除审核合格的工作")
                    }

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    },
    created() {
        this.username = this.$store.state.userinfo.username;
        // 获取当前用户的工作信息
        this.$axios({
            url: this.apiurl +
                "UserWork/FindWorkByUserId?id=" + this.$store.state.userid
        }).then((res) => {
            if (res.status == 200) {
                res.data.forEach(element => {
                    let trueOrfalse = '?';
                    if (element.isCheak == 1) {
                        trueOrfalse = '√'
                    }
                    else if (element.isCheak == 2) {
                        trueOrfalse = 'X'
                    }
                    let workinfo = {
                        id: element.workId,
                        name: element.name,
                        date: element.date,
                        worktype: element.workType,
                        ischeak: trueOrfalse,
                        content: element.workContent,
                        reporter: element.reporter
                    }
                    this.tableDataList.push(workinfo)
                });
            }
        }, (err) => {
            console.log(err.message);
        });
        //获取所有用户信息，作为添加工作时，汇报人的信息
        this.$axios({
            url: this.apiurl +
                "UserLogin/GetAllUser"
        }).then((res) => {
            if (res.status == 200) {
                res.data.forEach(element => {
                    let reporterinfo = {
                        value: element.name,
                        label: element.name
                    }
                    this.options.push(reporterinfo)
                });
            }

        }, (err) => {
            console.log(err.message);
        });
    }
}
</script>